"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../../constants");
exports.Row = styled_1.default.tr({
    borderBottom: `1px solid ${constants_1.Color.GREY}`,
});
